module.exports = __webpack_public_path__ + "static/media/hamburger.57151c77.svg";